﻿import React from 'react';
import { str_isEmpty } from '@Util/Utils';
import { Table_Data_Type } from '@Util/Types';

export default function Table_Data(p: Table_Data_Type): JSX.Element {

    function generateClassName(): string {
        let className = "Table_Data";

        if (!str_isEmpty(p.className)) {
            className += ` ${p.className}`;
        }

        return className;
    }

    return (
        <td
            className={generateClassName()}
            align={p.align}
            colSpan={p?.colSpan}
            style={p?.style}
        >
            {p.children}
        </td>
    );
}